"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const fa_1 = require("react-icons/fa");
const styles_1 = require("./styles");
exports.AdminButton = (props) => {
    if (props.admin) {
        return (react_1.default.createElement(styles_1.PageHeaderButtons, null,
            react_1.default.createElement(styles_1.PageUserButton, { to: "/listarParticipantes" },
                react_1.default.createElement(fa_1.FaUserFriends, null))));
    }
    return null;
};
